//	eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(props) {
  return null;
}
Column.displayName = 'Column';
export default Column;